import { useMemo } from 'react';
import { endOfDay, startOfDay, startOfMonth, subDays } from 'date-fns';
export function usePreconfiguredPeriods() {
    return useMemo(() => [
        { name: 'Сегодня', start: startOfDay(new Date()), end: endOfDay(new Date()) },
        { name: 'Вчера', start: startOfDay(subDays(new Date(), 1)), end: endOfDay(subDays(new Date(), 1)) },
        { name: 'Неделя', start: startOfDay(subDays(new Date(), 7)), end: endOfDay(new Date()) },
        { name: 'Месяц', start: startOfDay(subDays(new Date(), 31)), end: endOfDay(new Date()) },
        { name: 'Этот месяц', start: startOfMonth(new Date()), end: endOfDay(new Date()) }
    ], []);
}
